export default "__VITE_ASSET__t2CiwINn__"